module.exports = __webpack_public_path__ + "static/media/kgp-slide-2.65069d6d.jpg";